/**
 * Full TblFacility interface - maps to C# TblFacility model.
 * System.Text.Json camelCase serialization (e.g., PKey_Facility → pKey_Facility).
 */
export interface TblFacility {
  pKey_Facility: number;
  facility_Name: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  fax: string;
  fac_Type: number;
  cardex_History: number;
  break_Name: string;
  lunch_Name: string;
  dinner_Name: string;
  wgt_Trig_1: number;
  wgt_Trig_2: number;
  wgt_Trig_3: number;
  wgt_Day_1: number;
  wgt_Day_2: number;
  wgt_Day_3: number;
  use_Color: boolean;
  color_Facility_Type_Argb: number;
  color_Portion_Small_Argb: number;
  color_Portion_Large_Argb: number;
  color_Special_Devices_Argb: number;
  color_Dislikes_Argb: number;
  color_Allergies_Argb: number;

  // Lab labels (1-34)
  lab01: string; lab02: string; lab03: string; lab04: string; lab05: string;
  lab06: string; lab07: string; lab08: string; lab09: string; lab10: string;
  lab11: string; lab12: string; lab13: string; lab14: string; lab15: string;
  lab16: string; lab17: string; lab18: string; lab19: string; lab20: string;
  lab21: string; lab22: string; lab23: string; lab24: string; lab25: string;
  lab26: string; lab27: string; lab28: string; lab29: string; lab30: string;
  lab31: string; lab32: string; lab33: string; lab34: string;

  fluid_Warning: number;
  use_IBW_Table: boolean;
  start_Day_Nourish_Accept: number;
  start_Day_Meal_Accept: number;
  start_Day_Med_Pass_Accept: number;
  color_Portion_Double_Argb: number;
  color_Portion_Double_Entree_Argb: number;
  color_TT_Label_B_Argb: number;
  color_TT_Label_F_Argb: number;
  color_Transparency_Level: number;

  // Meal costs
  meal_Cost_Large_B: number;
  meal_Cost_Large_L: number;
  meal_Cost_Large_D: number;
  meal_Cost_Double_B: number;
  meal_Cost_Double_L: number;
  meal_Cost_Double_D: number;
  meal_Cost_Dbl_Ent_B: number;
  meal_Cost_Dbl_Ent_L: number;
  meal_Cost_Dbl_Ent_D: number;

  nourishRPT_IncludeAll: boolean;
  color_TT_Background_Labels_Argb: number;
  background_Text_Level: number;

  // Tray ticket display
  tTD_Room_No: boolean;
  tTD_Diet_Type: boolean;
  tTD_SF_Condiments: boolean;
  tTD_Consist: boolean;
  tTD_Feeding_Status: boolean;
  tTD_Special_Devices: boolean;
  tTD_Portion: boolean;
  tTD_Location: boolean;
  tTD_Allergies: boolean;
  tTD_Messages: boolean;
  tTD_Display_Duplicate_Message: boolean;
  tTD_Meal_Items: boolean;
  tTD_Beverages: boolean;
  tTD_Dislikes: boolean;
  tTD_Note: boolean;
  tTD_ShowLikes: boolean;
  tTD_PrintBarcode: boolean;

  autoNote_DietOrder: boolean;
  autoNote_Weight: boolean;
  dF_Flag_Weight_Interval: number;
  dF_Flag_DietOrderReview_Interval: number;
  dF_Flag_Nutritional_Assessment_Interval: number;
  start_Day_Posting_Menu: number;

  // Tray ticket settings
  tT_DefaultPrintOrder: number;
  trayTicket_PrintBDayCake: boolean;
  printBarcode: boolean;
  useProduction: boolean;
  dF_Tube_Feed: number | null;
  // Nourishment names
  nourish_Name_EAM: string;
  nourish_Name_AM: string;
  nourish_Name_PM: string;
  nourish_Name_HS: string;
  nourish_Name_PM2: string;
  nourish_Name_HS2: string;

  trayTicketPaperType: number;
  tT_DisplayCNA: boolean;
  useExtensionSheetColor: boolean;
  cardex_Attendance: number;
  cardexHistoryMax_Weights: number;
  cardexHistoryMax_Medications: number;
  printItemsMarkedAsCondimentsPostingGeneralMenu: boolean;
  printItemsMarkedAsCondimentsPostingExtensionSheets: boolean;
  printDislikesBasedOnMenuCycle: boolean;
  padResidentID: boolean;
  generalPostingMenuFontSize: number;
  residentPostingMenuFontSize: number;
  productionTallyFontSize: number;
  tT_VisualizerQueuing: boolean;
  tT_UseCapsOnItems: boolean;
  specialEventHeaderNote: string;
  specialEventFooterNote: string;
  specialEventSpecialRequestCount: number;
  key_Nourishment_Acceptance: string;
  key_MedPass_Acceptance: string;
  posting_Alternates_Default: number;
  selectiveMenu_ShowSizes: boolean;
  dailyMenuFontSize: number;
  pT_IncludeMealPatternThickenerItems: boolean;
  showLikesDislikesOnResidentDataGrid: boolean;
  extensionSheets_OnlyWhenRequestedAbrev: string;
  fKey_Diet_Type_House: number | null;
  fKey_RC_DRI_Group_Default: number | null;
  color_TT_SpecialNeeds_Argb: number;
  doNotShowMealAcceptanceKey: boolean;
  selectiveMenuFontSize: number;
  selectiveMenuUseMenuName: boolean;
  pT_EvenBackgroundColor: number;
  generalPostingMenu2FontSize: number;
  showBasicNutritionalInformation: boolean;
  mC_ClearDuplicateOverrideItem: boolean;
  nourishmentAcceptanceInitialBy: string;
  mealAcceptanceInitialBy: string;
  tT_MultipleDayPrintType: number;

  // Resident display columns
  showResidentDFColumn: boolean;
  showResidentPrescriberColumn: boolean;
  showResidentPhotoColumn: boolean;
  extensionSheets_OnlyShowItemType: boolean;
  pT_Extended_EvenBackgroundColor: number;
  extensionSheetFontSize: number;
  extensionSheets_GroupAlternateItems: boolean;
  extensionSheet_NotAllowedText: string;
  setName: string;
  extensionSheet_ShowRedundantSizes: boolean;
  mealAcceptance_OtherLines: string;
  printLikesBasedOnMenuCycle: boolean;
  tT_ShowLikes: boolean;
  color_TT_Likes_Argb: number;
  tT_PrintOrder: number;
  pT_ReportType: number;
  postingMenu_DietSpecific_ShowSizes: boolean;
  postingMenu_ResidentSpecific_ShowSizes: boolean;
  mealAcceptance_PrintSupplements: boolean;
  color_TT_Notes_Argb: number;
  wgt_Grace_1: number;
  wgt_Grace_2: number;
  wgt_Grace_3: number;
  postingMenu_ResidentSpecific_ShowConsist: boolean;
  pT_PrecheckNotesAdvancedPrep: boolean;
  useAssessment: boolean;
  nourishmentAcceptance_PrintSupplements: boolean;

  // Labels
  specialDevice: string;
  prescriber: string;
  labVisibleAssessment: string;
  facility: string;
  wing: string;
  room: string;
  admit: string;

  skipBlankMeals: boolean;
  selectiveMenuShowConsistency: boolean;
  postingMenu_DietSpecific_ShowConsistency: boolean;
  postingMenu_Selective_ShowConsistency: boolean;
  postingMenu_Selective_ShowSize: boolean;

  // Protein albumin levels
  proteinAlbuminLevelMildLow: number;
  proteinAlbuminLevelMildHigh: number;
  proteinAlbuminLevelModerateLow: number;
  proteinAlbuminLevelModerateHigh: number;

  defaultWeightTypes_FluidNeeds: number;
  defaultWeightTypes_ProteinNeeds: number;
  defaultWeightTypes_CalorieNeeds: number;
  needsCalorieRange: number;

  wgt_Warning_1: number;
  wgt_Warning_2: number;
  wgt_Warning_3: number;
  weightMatrixShowBMI: boolean;
  weightMatrixShowHeight: boolean;
  useResidentID: boolean;
  /** Location is picked from tblUnit_Mapping (Unit) rather than typed as
   *  Floor + Wing. Optional: older API builds may not send it. */
  useUnitMapping?: boolean;

  timeOfDay_Days: string;
  timeOfDay_Evenings: string;
  timeOfDay_Nights: string;
  weightMatrixAlwaysDisplayDayNumber: boolean;
  facility_Plural: string;
  selectiveMenuNumberPerPage: number;
  selectiveMenuShowSpecialDevices: boolean;
  selectiveMenuShowFoodAllergies: boolean;
  selectiveMenuShowTrayLine: boolean;
  selectiveMenuShowSpecialNeeds: boolean;
  selectiveMenuShowFeedingStatus: boolean;
  selectiveMenuShowLocation: boolean;
  selectiveMenuShowServiceItems: boolean;
  residentDefaultAttendance: number;
  sM_ShowDayOfTheWeek: boolean;
  fKey_Diet_TypeNPO: number | null;
  selectiveMenuFormShowAllAlwaysServed: boolean;
  selectiveMenuSortByResident: boolean;
  postingMenu_General_ShowSize: boolean;
  web_Report_PrintInSilverlight: boolean;

  // Assessment limits
  assessment_MaxNumber_DietOrder: number;
  assessment_MaxNumber_Medications: number;
  assessment_MaxNumber_Weights: number;

  selectiveMenuShowStaticResidents: boolean;
  postingMenu_SelectiveMenu_ShowStaticResidents: boolean;
  nourishmentAcceptanceDaily_Signature: string;
  heightUseInchesOnly: boolean;

  // AIM settings
  aIM_Active: boolean;
  aIM_DietOrder_UpdateMealPattern: boolean;
  aIM_DietOrder_UpdateAdjustments: boolean;
  aIM_DietOrder_UpdateSelectiveMenus: boolean;
  aIM_MealPattern_UpdatePreviousMenus: boolean;
  aIM_MenuCycle_UpdatePreviousMenus: boolean;
  aIM_Item_UpdateMealPattern: boolean;
  aIM_Item_UpdateAdjustments: boolean;
  aIM_Item_UpdateSelectiveMenu: boolean;
  aIM_Item_UpdateMenuCycle: boolean;
  aIM_UpdateInBackground: boolean;
  aIM_UpdateMealPatternDietOverride: boolean;
  aIM_Notifications_SMGenerating: boolean;
  aIM_Notifications_SMCompleted: boolean;

  selectiveMenu_DefaultPrintOrder: number;
  extensionSheet_ShowServiceItem: boolean;
  pT_Extended_ShowPrintBy: boolean;
  pT_Summary_ShowPrintBy: boolean;
  cardex_ShowChewingAbility: boolean;
  color_Report_Label_B_Argb: number;
  color_Transparency_Level_Report_Label: number;
  lastLogin_DateTime: string | null;
  weight_TriggerType: number;
  notes_ShowTime: boolean;
  selectiveMenuTouch_ResidentOrder: number;
  selectiveMenu_ShowPortion: boolean;
  tT_OnePart_NameOnBottom: boolean;
  tT_OnePart_FontSize: number;
  birthdayReport_ShowDietOrder: boolean;
  birthdayReport_ShowAllergies: boolean;
  selectiveMenu_ShowMenuCategoryNames: boolean;
  showResidentHeight: boolean;

  assessment_LookBackHistory: number;
  assessment_MaxNumber_Recommendations: number;
  assessment_MaxNumber_NutritionalDiagProblem: number;
  assessment_MaxNumber_ProblemGoalsApproaches: number;
  assessment_MaxNumber_ProgressNotes: number;
  assessment_MaxNumber_Skin: number;

  useDischargedDate: boolean;
  intakeStudy_ReportType: number;
  flag_Weight_Temp_Interval: number | null;
  flag_Weight_Temp_Days: number | null;
  selectiveMenu_IgnoreDoNotShowOnSelectiveMenu: boolean;
  selectiveMenu_IgnoreDoNotShowOnSelectiveMenu_Touch: boolean;

  // Protein/Fluid condition defaults
  protein_Condition_Other_Default: string;
  protein_Condition_AlbuminLow_Default: number | null;
  protein_Condition_AlbuminHigh_Default: number | null;
  protein_Condition_ProteinLow_Default: number | null;
  protein_Condition_ProteinHigh_Default: number | null;
  fluid_Condition_Other_Default: string;
  fluid_Condition_Low_Default: number | null;
  fluid_Condition_High_Default: number | null;

  cardex_MealPattern_Simple: boolean;
  resident: string;
  resident_Plural: string;
  labelReports_UseLabelSelector: boolean;
  weightMatrix_SortOrder: number;
  autoDeleteDischargedResidents: number;
  autoRemoveDeletedResidents: number;
  tT_OnePart_ShowPrintDateTime: boolean;
  selectiveMenu_UseHistoryForSelections: boolean;
  census_AutoDeleteDays: number;
  calorie_EnergyCalculation: number;
  mealAcceptance_DisplayXInsteadOfShadedBox: boolean;

  // Guest tray ticket
  tT_Guest_Display_Birthdate: boolean;
  tT_Guest_Display_FoodAllergies: boolean;
  tT_Guest_Message: string;
  tT_Guest_PrintLocation: number;
  tT_Guest_PrintTogetherCount: number;
  tT_Guest_DeleteDays: number;
  tT_Guest_StartNewPage: boolean;

  assessment_ResidentCompliant_CheckboxLabel: string;
  problemGoalApproach: string;
  problemsGoalApproach_ShowInitials: boolean;
  problemsGoalApproach_ShowResolved: boolean;
  problemsGoalApproach_SignatureOptions: number;
  problemsGoalApproach_ShowSignatureOnBottom: boolean;
  problemsGoalApproach_ShowReviewedDate: boolean;

  showResidentAge: boolean;
  showResidentAssessedDate: boolean;
  showResidentBirthDate: boolean;
  showResidentLinkedIDColumn: boolean;
  showResidentAdmitDateColumn: boolean;
  resident_Possessive: string;
  tT_ItemText: number;
  extensionSheets_PageBreak: boolean;
  showSpecialDeviceMealtime: boolean;

  // Report colors
  color_Report_Group_Background_Argb: number;
  color_Report_Group_Foreground_Argb: number;
  color_Report_Group_Border_Argb: number;

  pT_GroupChildWithParent: boolean;
  postingMenu_AlternateSeparateGroup: boolean;
  pT_DefaultSelectiveMenuFilter: number;
  pT_DisplaySelectiveMenuFilter: boolean;
  autoIncrementResidentID: boolean;
  logInteractionWithResidents: boolean;
  logInteractionWithResidents_Duration: number;
  labFormulas: string;
  residentDatagrid_DefaultSortOrder: number;
  recommendationsFontSize: number;
  tT_ColorConsistencies: boolean;

  selectiveMenuTouchShowResidentPhoto: boolean;
  displayTrayLineAssignOnRoomChange: boolean;
  showResidentBMIColumn: boolean;
  showResidentWeightColumn: boolean;
  fKey_Consist_Regular: number | null;
  selectiveMenuNumberOfChoices_B: number | null;
  selectiveMenuNumberOfChoices_L: number | null;
  selectiveMenuNumberOfChoices_D: number | null;
  mP_ShowChewingAbility: boolean;
  birthdayReport_BasedOnPrintDate: boolean;
  mealAcceptance_ShowDietOrder: boolean;
  medPass_ShowDietOrder: boolean;
  postingMenu_PaperSize: number;
  weightMatrix_DecimalPlaces: number;
  selectiveMenuTouchDefaultSelection: number;
  cC_ML_Label: string;
  tT_OnePart_ShowUser: boolean;
  medPassNourishmentAcceptance_DisplayXInsteadOfShadedBox: boolean;
  medications_ShowStartDate: boolean;
  medications_ShowEndDate: boolean;
  tT_ShowItemSize: boolean;
  tT_Display_DOB_ID: number;
  selectiveMenuTouchASOpacity: number;
  selectiveMenu_DefaultPageOrder: number;
  nourishmentAcceptance_IncludeMedPass: boolean;
  pT_Unit_ShowPrintBy: boolean;
  extensionSheets_ShowDates: boolean;
  tT_OnePart_NoteLocation: number;
  selectiveMenuTouchEnableMealScheduling: boolean;
  pT_Extended_SortByItem: boolean;
  pT_Summary_SortByItem: boolean;
  pT_ByFloor_SortByItem: boolean;
  selectiveMenuTouchDisplayNumberChoice: boolean;
  hepaticFailure_Low: number;
  hepaticFailure_High: number;
  facility_Possessive: string;
  tT_FloorWingRoomOnBottom: boolean;
  tT_DietOrderOnBottom: boolean;
  nourishmentLabel_ShowDietOrder: boolean;
  pT_CombineFilterReports: boolean;
  pT_RecipeIndicator: string;
  posting_SpecificResident_NumberOfChoices_B: number;
  posting_SpecificResident_NumberOfChoices_L: number;
  posting_SpecificResident_NumberOfChoices_D: number;

  // Discharge summary options
  discharge_RequiredFluids: boolean;
  discharge_RequiredProtein: boolean;
  discharge_BMI: boolean;
  discharge_ReceivedProtein: boolean;
  discharge_TrayLine: boolean;
  discharge_MealPattern: boolean;
  discharge_Nourishments: boolean;
  discharge_Adjustments: boolean;
  discharge_LabResults: boolean;
  discharge_WeightHistory: boolean;
  discharge_MealAcceptance: boolean;
  discharge_FluidAcceptance: boolean;
  discharge_SupplementAcceptance: boolean;
  discharge_RequiredCalories: boolean;
  discharge_SummaryComments: boolean;
  discharge_PromptForSummary: boolean;

  recipe_ShowWeightColumn: boolean;
  tT_ThreePart_ShowResidentImage: boolean;
  selectiveMenu_UseTTColor: boolean;
  tT_ShowDayOfTheWeek: number;
  selectiveMenu_Footer: number;
  selectiveMenu_GroupCondiments: boolean;
  selectiveMenu_Condiments_DisplayName: boolean;
  selectiveMenu_Condiments_Name: string;
  selectiveMenu_GroupAlwaysServed: boolean;
  selectiveMenu_AlwaysServed_DisplayName: boolean;
  selectiveMenu_AlwaysServed_Name: string;
  selectiveMenu_AlwaysServed_AllowAsPrimaryChoice: boolean;
  residentList_Labels_ShowAllergy: boolean;
  residentList_Labels_Type: number;
  posting_SpecificResident_UseSelectiveMenuHistory: boolean;
  residentDatagrid_Notices_NoDietOrder: boolean;
  residentDatagrid_Notices_NoTrayLine: boolean;
  intake_AllowOneDay: boolean;
  intake_AllowTwoDay: boolean;
  intake_AllowThreeDay: boolean;
  intake_AllowFourDay: boolean;
  intake_AllowFiveDay: boolean;
  intake_AllowSixDay: boolean;
  intake_AllowSevenDay: boolean;
  postingMenu_ResidentSpecific_ShowItemType: boolean;
  postingMenu_ResidentSpecific_ShowPortion: boolean;
  isCorporate: boolean;
  pT_ShowDate: boolean;
  fKey_Dietech_Location: number | null;
  fKey_Dietech_Location_Sub: number | null;
  recipe_Census: number;
  extensionSheet_PrintGarnish: boolean;
  extensionSheet_PrintNotes: boolean;

  // Selective Menu Touch
  selectiveMenuTouchActAsPOS: boolean;
  selectiveMenuTouchShowCreditSummary: boolean;
  selectiveMenuTouchShowConsistency: boolean;
  selectiveMenuTouchShowItemType: boolean;
  selectiveMenuTouchShowServiceItem: boolean;
  selectiveMenuTouchShowWholePortions: boolean;
  selectiveMenuTouchShowTicketPreview: boolean;
  selectiveMenuTouchTicketPreviewShowPrice: boolean;

  // Credits
  useCredits: boolean;
  creditsAutoRefill: boolean;
  salesTax: number;
  credits_BillToAccount: string;
  credits_Breakfast: boolean;
  credits_Lunch: boolean;
  credits_Dinner: boolean;
  credits_GroupLunchDinner: boolean;
  credits_GuestOnlyTransactions: boolean;
  credits_MenuTitle: string;
  credits_ActAsPOS_Name: string;
  credits_NotPresentRefundDays: number;
  credits_NotPresentRefundAmount: number;
  dateTimeCreditsLastProcess: string | null;

  selectiveMenuTouchSeparateAlwaysServed: boolean;
  color_Report_EvenBackgroundColor: number;
  color_Mealtime_TT_Argb: number;
  color_Mealtime_SM_Argb: number;
  postingMenu_DietSpecific_ShowItemType: boolean;
  postingMenu_Selective_ShowItemType: boolean;
  selectiveMenuTouchShowMenuCategoryFilter: boolean;
  purchasing_UseDepartments: boolean;
  purchasing_POPrefix: string;
  weightEntry_StartDay: number;

  // EHR/EMR
  facilityEhrUniqueIdentifier: string;
  facilityEhrActive: boolean;
  eHR_Title: string;
  eHR_ID: string;
  eMR_DatabaseName: string;
  eHR_AutoDuration: number;
  eHR_Admission_IsAuto: boolean;
  eHR_DietOrder_IsAuto: boolean;
  eHR_Discharge_IsAuto: boolean;
  eHR_GeneralOrder_IsAuto: boolean;
  eHR_DietOrder_AIM: boolean;
  eHR_ProcessPendingDiets: boolean;
  eHR_DietOrderCummulative: boolean;
  eHR_DoNotProcess_Allergies: boolean;
  eHR_DoNotProcess_DietOrder: boolean;
  eHR_DoNotProcess_OutPatient: boolean;
  eHR_DoNotProcess_Units: boolean;
  dietOrderLocking_Active: boolean;
  eHR_DietUnlock_Hours: number;
  eHR_EnableFreeTextDiets: boolean;
  eHR_MustMatchVisitNumberToDischarge: boolean;
  eHR_DischargeDisregardDays: number;
  eHR_UpdateDisregardDays: number;
  eHR_Discharge_Action: number;
  eHR_Leave_Action: number;
  eHR_OutPatient_Action: number;
  eHR_Update_Action: number;
  eHR_EnableAdmitSource: boolean;
  eHR_AdmitSource_IgnoreUnmatchedMessages: boolean;
  fKey_Facility_EHRShare: number | null;
  eHR_DoNotUpdateEmptyValues: boolean;
  eHR_EnableTrayLineAssign: boolean;
  eHR_TrayLine_Set_B: number | null;
  eHR_TrayLine_Set_L: number | null;
  eHR_TrayLine_Set_D: number | null;
  eHR_StripNonNumericCharacters: number;

  // Selective Menu Touch colors
  selectiveMenuTouch_OrderSaved_Fore_Color: number;
  selectiveMenuTouch_OrderSaved_Back_Color: number;
  selectiveMenuTouch_NoOrder_Fore_Color: number;
  selectiveMenuTouch_NoOrder_Back_Color: number;
  selectiveMenuTouch_NPO_Fore_Color: number;
  selectiveMenuTouch_NPO_Back_Color: number;
  selectiveMenuTouch_Printed_Fore_Color: number;
  selectiveMenuTouch_Printed_Back_Color: number;
  selectiveMenuTouch_PrintedNotSaved_Fore_Color: number;
  selectiveMenuTouch_PrintedNotSaved_Back_Color: number;
  selectiveMenuTouch_UseUnitColor: boolean;
  selectiveMenu_UseUnitColor: boolean;
  trayTicket_UseUnitColor: boolean;

  // Selective Menu Touch display
  selectiveMenuTouch_StartScreen: number;
  selectiveMenuTouch_AfterOrderScreen: number;
  selectiveMenuTouch_ShowMenuCategory: boolean;
  selectiveMenuTouch_UsePOS2: boolean;
  selectiveMenuTouch_ItemText: number;
  selectiveMenuTouch_ShowDOB: boolean;
  selectiveMenuTouch_ShowScrollButtons: boolean;
  selectiveMenuTouch_ShowNutritionalInfo: boolean;
  selectiveMenuTouch_PrioritizeRoom: boolean;
  selectiveMenuTouch_EmployeeSessionType: number;
  selectiveMenuTouch_StartDateToday: boolean;
  selectiveMenuTouch_MealChoice_Enabled: boolean;
  selectiveMenuTouch_MealChoice_Count: number;
  selectiveMenuTouch_MealtimeCount: number;
  selectiveMenuTouchShowItemEducation: boolean;
  selectiveMenu_Color_Transparency_Level: number;

  // Timezone
  timeZone_UseDST: boolean;
  timeZone_ID: string;

  // Selective Menu Flags
  selectiveMenu_Flag1: string; selectiveMenu_Flag2: string;
  selectiveMenu_Flag3: string; selectiveMenu_Flag4: string;
  selectiveMenu_Flag5: string; selectiveMenu_Flag6: string;
  selectiveMenu_Flag7: string; selectiveMenu_Flag8: string;
  selectiveMenu_Flag9: string; selectiveMenu_Flag10: string;
  selectiveMenu_Flag11: string; selectiveMenu_Flag12: string;
  selectiveMenu_Flag13: string; selectiveMenu_Flag14: string;
  selectiveMenu_Flag15: string; selectiveMenu_Flag16: string;
  selectiveMenu_Flag1_FKey_Item: number | null;
  selectiveMenu_Flag2_FKey_Item: number | null;
  selectiveMenu_Flag3_FKey_Item: number | null;
  selectiveMenu_Flag4_FKey_Item: number | null;
  selectiveMenu_Flag5_FKey_Item: number | null;
  selectiveMenu_Flag6_FKey_Item: number | null;
  selectiveMenu_Flag7_FKey_Item: number | null;
  selectiveMenu_Flag8_FKey_Item: number | null;
  selectiveMenu_Flag9_FKey_Item: number | null;
  selectiveMenu_Flag10_FKey_Item: number | null;
  selectiveMenu_Flag11_FKey_Item: number | null;
  selectiveMenu_Flag12_FKey_Item: number | null;
  selectiveMenu_Flag13_FKey_Item: number | null;
  selectiveMenu_Flag14_FKey_Item: number | null;
  selectiveMenu_Flag15_FKey_Item: number | null;
  selectiveMenu_Flag16_FKey_Item: number | null;

  // More misc
  mealPattern_ShowWarnings: boolean;
  postingMenu_General_ShowServiceItem: boolean;
  postingMenu_DietSpecific_ShowServiceItem: boolean;
  postingMenu_SelectiveMenu_ShowServiceItem: boolean;
  postingMenu_SpecificResident_ShowServiceItem: boolean;
  tT_CompressTrayline: boolean;
  tT_UseSeparatorPage: boolean;
  usePreferredNameOnlyOnReports: boolean;
  autoTrayLineNewResident: boolean;
  tT_Duplicate_PrintLocation: number;
  postingMenu_DietSpecific_AlternateSeparateGroup: boolean;
  tT_ShowLocationColumns: boolean;
  postingMenu_SelectiveMenu_FreeText: string;
  postingMenu_DailyFullDay_FreeText: string;
  sM_IncludeNPO: boolean;
  postingMenu_DailyMenuFullHeader_FontSize: number;
  postingMenu_DailyMenuFull_CenterItems: boolean;
  postingMenu_Daily_MealtimeLabel: number;
  notes_UpperCase: boolean;
  extensionSheet_GroupExtras: boolean;

  // Mealtimes
  morning_Time: string;
  mid_Time: string;
  evening_Time: string;
  eaM_Time: string | null;
  aM_Time: string | null;
  pM_Time: string | null;
  pM2_Time: string | null;
  hS_Time: string | null;
  hS2_Time: string | null;

  // Nourishment sort orders / associated meals
  nourish_EAM_AssociatedMeal: number;
  nourish_AM_AssociatedMeal: number;
  nourish_PM_AssociatedMeal: number;
  nourish_PM2_AssociatedMeal: number;
  nourish_HS_AssociatedMeal: number;
  nourish_HS2_AssociatedMeal: number;
  nourish_EAM_SortOrder: number;
  nourish_AM_SortOrder: number;
  nourish_PM_SortOrder: number;
  nourish_PM2_SortOrder: number;
  nourish_HS_SortOrder: number;
  nourish_HS2_SortOrder: number;

  // Tray ticket selective menu
  tT_SelectiveMenu_Normal_SMNE: number;
  tT_SelectiveMenu_Normal_SME: number;
  tT_SelectiveMenu_Normal_Warning: boolean;
  tT_SelectiveMenu_Static_Warning: boolean;
  tT_SelectiveMenu_Static_SME: number;
  tT_SelectiveMenu_Static_SMNE: number;
  tT_HideTrayLineInRoomOrder: boolean;

  defaultResidentType: number;

  // Weight entry
  wgt_Entry_DefaultEntryMode: number;
  wgt_Entry_DateSort: number;
  wgt_Entry_PerChgW_1: number; wgt_Entry_PerChgW_2: number; wgt_Entry_PerChgW_3: number;
  wgt_Entry_PerChgW_4: number; wgt_Entry_PerChgW_5: number;
  wgt_Entry_PerChgM_1: number; wgt_Entry_PerChgM_2: number; wgt_Entry_PerChgM_3: number;
  wgt_Entry_PerChgM_4: number; wgt_Entry_PerChgM_5: number;
  wgt_Entry_AmtToPrintW: number;
  wgt_Entry_AmtToPrintM: number;
  wgt_Entry_MonthlyDisplay: number;
  wgt_Entry_WarningColor_Argb: number;
  wgt_Entry_PerChgW_1_Warning: number; wgt_Entry_PerChgW_2_Warning: number;
  wgt_Entry_PerChgW_3_Warning: number; wgt_Entry_PerChgW_4_Warning: number;
  wgt_Entry_PerChgW_5_Warning: number;
  wgt_Entry_PerChgM_1_Warning: number; wgt_Entry_PerChgM_2_Warning: number;
  wgt_Entry_PerChgM_3_Warning: number; wgt_Entry_PerChgM_4_Warning: number;
  wgt_Entry_PerChgM_5_Warning: number;

  bulkFirstChoice: boolean;
  facility_Name_Abbreviation: string;
  selectiveMenu_ShowDOB: boolean;

  // Special request labels
  specialRequest_LabelType: number;
  specialRequest_Label_ShowMPNote: boolean;
  specialRequest_Label_GroupItems: boolean;
  specialRequest_Label_ShowDietOrder: boolean;
  specialRequest_Label_ShowFeedingStatus: boolean;
  specialRequest_Label_ShowFoodAllergies: boolean;
  specialRequest_Label_NameType: number;
  specialRequest_Label_SortType: number;

  residentList_InsertBlankRow: boolean;
  guiD: string;
  cardex_DisplayOptions: boolean;
  cardex_Portrait: boolean;
  tT_Display_TubeFeed: boolean;
  tT_Duplicate_Display_TubeFeed: boolean;
  tT_OnePart_4x4_NoteLocation: number;
  tT_OnePart_4x4_FontSize: number;
  dishUpLabels_ShowLines: boolean;
  color_TT_Location: number;
  color_TT_Location_Back: number;
  postingMenu_DailyFullDay_Portrait: boolean;

  // Resident list indexes
  residentList_FloorWing_Index: number;
  residentList_Room_Index: number;
  residentList_Discharged_Index: number;
  residentList_Name_Index: number;
  residentList_DietOrder_Index: number;
  residentList_SugarFree_Index: number;
  residentList_Birthday_Index: number;
  residentList_Age_Index: number;
  residentList_Height_Index: number;
  residentList_Weight_Index: number;
  residentList_Dislikes_Index: number;
  residentList_TTNote_Index: number;
  residentList_MatColor_Index: number;
  residentList_Allergies_Index: number;
  residentList_SpecialDevices_Index: number;
  residentList_FeedingStatus_Index: number;
  residentList_Orientation_IsPortrait: boolean;
  residentList_Scale: number;
  residentList_UseEvenBackgroundColor: boolean;
  residentList_Gender_Index: number;
  residentList_ID_Index: number;
  residentList_SMNotes_Index: number;
  residentList_Labels_DisplayOption: number;
  residentList_Labels_B_Type: number;
  residentList_Labels_B_DisplayOption: number;
  residentList_Labels_B_ShowDate: boolean;

  // Resident list extended indexes
  residentListExtended_FloorWing_Index: number;
  residentListExtended_Room_Index: number;
  residentListExtended_Name_Index: number;
  residentListExtended_DietOrder_Index: number;
  residentListExtended_Allergies_Index: number;
  residentListExtended_SpecialDevices_Index: number;
  residentListExtended_FeedingStatus_Index: number;
  residentListExtended_MatColor_Index: number;
  residentListExtended_Orientation_IsPortrait: boolean;
  residentListExtended_Scale: number;
  residentListExtended_SugarFree_Index: number;
  residentListExtended_Dicharged_Index: number;
  residentListExtended_Birthday_Index: number;
  residentListExtended_Age_Index: number;
  residentListExtended_Height_Index: number;
  residentListExtended_Weight_Index: number;
  residentListExtended_Dislikes_Index: number;
  residentListExtended_TTNote_Index: number;
  residentListExtended_Gender_Index: number;
  residentListExtended_ID_Index: number;
  residentListExtended_SMNotes_Index: number;
  residentListExtended_SpecialNeeds_Index: number;

  residentLabel_IncludeNotOnTrayLine: boolean;
  residentLabel_B_IncludeNotOnTrayLine: boolean;
  color_TT_DietOverrideDate: number;
  color_TT_MealItemNotes: number;
  cardex_Default_Selection: number;

  // More TT one-part settings
  tT_OnePart_ShowDiet: boolean;
  tT_OnePart_ShowMealTray: boolean;
  tT_OnePart_Portion_Index: number;
  tT_OnePart_Item_Index: number;
  tT_OnePart_ItemType_Index: number;
  tT_OnePart_ServiceItem_Index: number;
  tT_OnePart_Consist_Index: number;
  tT_OnePart_Size_Index: number;
  tT_OnePart_LeftMargin: number;
  tT_OnePart_RightMargin: number;
  tT_OnePart_TopMargin: number;

  printers_EnablePrinterCategories: boolean;
  nourishmentLabel_NameType: number;
  nourishmentLabel_Sort: number;
  nourishmentLabel_ShowFeedingStatus: boolean;
  nourishmentLabel_ShowFoodAllergies: boolean;
  mealAcceptance_InsertBlankRow: boolean;
  extensionSheet_BorderColor: number;
  postingMenu_DailyMenuFull_FontSize: number;
  tT_NameType: number;
  forceRoomBedSelection: boolean;
  selectiveMenuDefaultSelection: number;
  displayTrayLineAssignOnAdmit: boolean;
  extenstionSheet_ScaleFactor: number;
  postingMenu_DietSpecific_ScaleFactor: number;
  postingMenu_General_ScaleFactor: number;
  postingMenu_Selective_ScaleFactor: number;
  postingMenu_SpecificResident_ScaleFactor: number;
  fKey_Prd_Menu_Category_Primary: number | null;
  postingMenu_DietSpecific_Portrait: boolean;
  postingMenu_General_Portrait: boolean;
  postingMenu_Extension_Portrait: boolean;
  postingMenu_Daily_DateFormat_Index: number;
  postingMenu_DailyFullDay_DateFormat_Index: number;
  tT_DefaultPrintType_Index: number;
  precheckDuplicateTrayTicket: boolean;
  adjustment_ShowReason: boolean;

  // Cardex meal pattern
  cardex_MP_Show_Diet: boolean;
  cardex_MP_Show_Consist: boolean;
  cardex_MP_Show_Dentition: boolean;
  cardex_MP_Show_FeedingStatus: boolean;
  cardex_MP_Show_SpecialDevices: boolean;
  cardex_MP_Show_FoodAllergies: boolean;
  cardex_MP_Show_TTNotes: boolean;
  cardex_MP_Show_VerticalMessage: boolean;
  cardex_MP_Show_Location: boolean;
  cardex_MP_Show_SpecialNeeds: boolean;
  cardex_MP_Group_ResidentInfo: boolean;
  cardex_MP_Group_NutritionalNeeds: boolean;
  cardex_MP_Group_Attendance: boolean;
  cardex_MP_Group_MealPattern: boolean;
  cardex_MP_Group_Nourishments: boolean;
  cardex_MP_Group_Adjustments: boolean;
  cardex_MP_Group_MedPass: boolean;
  cardex_MP_Show_Diagnosis: boolean;
  cardex_ShowPhoto: boolean;
  cardex_MP_ShowPhoto: boolean;

  nutritionalAnalysis_ShowDRI: boolean;
  nutritionalAnalysis_ShowCaloricComposition: boolean;
  nutritionalAnalysis_ShowNutrientTable: boolean;
  nutritionalAnalysis_ShowAllNutrients: boolean;
  residentDataGrid_UseEvenBackgroundColor: boolean;
  dashboardPreviousHours: number;
  nourishment_Labels_Type: number;
  color_Allergies_B_Argb: number;

  aD_FacilityID: string;
  pT_ShowCookTo_Extended: boolean;
  pT_ShowCookTo_Summary: boolean;
  pT_ShowHoldTemp_Extended: boolean;
  pT_ShowHoldTemp_Summary: boolean;
  pT_ShowTT_Extended: boolean;
  pT_ShowTT_Summary: boolean;
  pT_ShowLO_Extended: boolean;
  pT_ShowLO_Summary: boolean;
  pT_ProductionArea_StartNewPage: boolean;
  mealPattern_StartDay: number;
  adjustment_StartDay: number;
  dishUpLabels_LabelType: number;
  extensionSheet_ItemTextType: number;
  selectiveMenu_ShowBirthday: boolean;
  useIngredientAllergies: boolean;
  weightHistory_SortOrder: number;
  groceryList_RoundUnits: boolean;
  prepPull_RoundUnits: boolean;
  resident_RemoveFromTraylineOnDischarge: boolean;
  intakeStudy: string;
  prepPull_LookOutDays: number;
  groceryList_LookOutDays: number;
  selectiveMenu_PaperSize: number;
  feedingStatus_MDS_Visible: boolean;
  feedingStatus_PRI_Visible: boolean;
  feedingStatus_Facility_Visible: boolean;
  feedingStatus_FreeText_Visible: boolean;
  weightEntry_DisplayFluidNeeds: boolean;
  pT_Extended_ShowUntensil: boolean;
  pT_ShowMultiFacility: boolean;
  /** Semicolon-delimited PKey_Facility list combined into multi-facility reports. */
  reports_MultiFacilityList: string | null;
  residentDG_ShowEHRDietOrder: boolean;
  sM_ReportType: number;
  clearDietOnDischarge: boolean;
  sM_NameType: number;
  chargeableLabel_Type: number;
  guestAttendanceSelective: boolean;
  fKey_Menu_Header_Employee: number | null;
  useDataCache: boolean;
  tT_ShowBulkOrders: boolean;
  runtimeToUse: number;
  lastCensusProcessed: string | null;
  pT_Employee_GroupChildParent: boolean;
  pT_ShowNourishments: boolean;
  mealPatternShortDescription: string;
  mealPatternLongDescription: string;
  adjustmentsShortDescription: string;
  adjustmentsLongDescription: string;

  // Purchasing padding
  purchasing_Padding_Breakfast: number;
  purchasing_Padding_Lunch: number;
  purchasing_Padding_Dinner: number;

  extensionSheet_ShowSignature: boolean;
  extensionSheet_SignatureType: number;

  driGroup_AutoSelectBasedOnDiet: boolean;

  // Bedside Ordering
  bedsideOrdering_Enabled: boolean;
  bedsideOrdering_CutoffMinutes: number;
  bedsideOrdering_AllowNextMealOrdering: boolean;
  bedsideOrdering_ShowPhotos: boolean;
  bedsideOrdering_RequireConfirmation: boolean;
  bedsideOrdering_MaxItemsPerCategory: number;
  bedsideOrdering_FontScale: number;

  // Self-Order Photos
  selfOrder_ShowPhotos: boolean;

  // Room Service / On-Demand Dining
  roomService_Enabled: boolean;
  roomService_DefaultCutoffMinutes: number;
  roomService_AllowCrossMealtimeItems: boolean;

  // Kitchen Display System (KDS)
  kDS_Enabled: boolean;
  kDS_CutoffMinutes: number;
  kDS_DefaultTargetPrepMinutes: number;
  kDS_RushTargetPrepMinutes: number;
  kDS_LateTrayTargetPrepMinutes: number;
  kDS_DeliverySLAMinutes: number;
  kDS_MaxMinutesPlaced: number;
  kDS_MaxMinutesAccepted: number;
  kDS_MaxMinutesPreparing: number;
  kDS_AutoEscalateEnabled: boolean;
  kDS_AutoEscalateMinutes: number;
  kDS_AutoEscalateAction: number;
  kDS_AutoReadyEnabled: boolean;
  kDS_AutoReadyMinutes: number;

  // PPID (Positive Patient Identification) — two-scan tray delivery.
  // pPID_RequireScanForDelivery is the hard gate; pPID_IdentifierSource: 0 = Dietech key, 1 = MRN.
  pPID_Enabled: boolean;
  pPID_RequireScanForDelivery: boolean;
  pPID_IdentifierSource: number;

  /** "Show IDDSI levels on printouts" (Reports > General, default off): tray tickets, Consistency - Census, Diet Order - List. */
  showIddsiOnPrintouts: boolean;

  /** Posting menu designs: the accent color the resident-facing designs print (ARGB, like the Color_*_Argb columns). Null = the default dark teal. Web migration add-posting-design-branding.sql. */
  postingMenu_AccentArgb?: number | null;

  eHR_UseHouseDiet: boolean;
  eMR_DisableLocalProcessing: boolean;
  labelReports_ShowDOB: boolean;
  eMR_SetMPEndDateOnReadmit: boolean;
  menuCycle_ShowNourishments: boolean;
  tT_DoNotPrintEmptyDiets: boolean;
  tT_3Part_Legal: boolean;

  // Additional fields that may exist on the API response
  [key: string]: unknown;
}

export type FacilitySettings = TblFacility;

/** Helper: convert .NET ARGB int to CSS hex color */
export function argbToHex(argb: number): string {
  // .NET stores colors as ARGB int (alpha in high byte)
  const r = (argb >> 16) & 0xff;
  const g = (argb >> 8) & 0xff;
  const b = argb & 0xff;
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

/**
 * Helper: convert CSS hex color back to .NET ARGB int (alpha=255).
 *
 * Returns a SIGNED 32-bit value, as .NET `Color.ToArgb()` does and as the int columns
 * (Color_*_Argb) store it: an opaque color always has the top bit set, so it is negative.
 * The unsigned form (e.g. 4294046746 for #f1f41a) is past Int32 and the API refuses the save.
 */
export function hexToArgb(hex: string): number {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16) || 0;
  const g = parseInt(clean.substring(2, 4), 16) || 0;
  const b = parseInt(clean.substring(4, 6), 16) || 0;
  // Alpha = 255 (fully opaque); `| 0` keeps it a signed Int32.
  return ((255 << 24) | (r << 16) | (g << 8) | b) | 0;
}

/** An ARGB value as the signed Int32 .NET stores; unsigned values (0x80000000-0xFFFFFFFF) wrap. */
export function toSignedArgb(value: number): number {
  return value | 0;
}
